import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";
import { useRecoilState } from "recoil";

import { previewDataState } from "src/recoil/atoms";
import getImageObject from "src/helpers/getImageObject";
import Flex from "src/components/UI/Structure/Flex";
import Box from "src/components/UI/Structure/Box";
import Label from "src/components/UI/Typography/Label";
import Artists from "src/components/Modules/Artists/Artists";
import Button from "src/components/UI/Button";

const RelatedArtists = ({ data, label, relatedArtists }) => {
  // Setup gatsby data
  const gatsbyArtists =
    relatedArtists?.length > 0
      ? relatedArtists
          .map((relatedArtist) => {
            const artist = data.allWpArtist.edges
              .filter(
                ({ node }) =>
                  node.databaseId === relatedArtist.databaseId &&
                  !node.acfArtistPage.hidden
              )
              .map(({ node: artist }) => {
                return {
                  id: artist.databaseId,
                  title: artist.title,
                  link: artist.link,
                  image: getImageObject(artist.featuredImage),
                  country: artist.acfArtistPage.country,
                };
              });
            return artist?.length > 0 ? artist[0] : null;
          })
          .filter((artist) => artist?.id)
      : [];

  // Get preview data
  const [previewData] = useRecoilState(previewDataState);
  const { artists } = previewData;

  const previewArtists =
    artists?.length > 0
      ? relatedArtists.map((relatedArtist) => {
          const artist = artists.filter(
            (artist) => artist.id === relatedArtist.ID
          );
          return artist[0];
        })
      : null;

  // Choose based on gatsby or preview data
  const selectedArtists = previewArtists ? previewArtists : gatsbyArtists;
  return (
    <Flex
      py={[6, null, null, 8]}
      justifyContent="space-between"
      alignItems="center"
      flexDirection="column"
      width={1}
      bg="gray.dark"
    >
      <Label>{label && label}</Label>
      <Box py={[8, null, null, 10]} width={12 / 12}>
        <Artists
          artists={selectedArtists}
          layout={selectedArtists.length <= 2 ? "center" : null}
          carousel
        />
      </Box>
      <Box>
        <Button
          label="Visa alla artister"
          size="large"
          link="/artister"
          border="dark"
        >
          Visa alla artister
        </Button>
      </Box>
    </Flex>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allWpArtist {
          edges {
            node {
              databaseId
              title
              link
              featuredImage {
                node {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        layout: CONSTRAINED
                        placeholder: DOMINANT_COLOR
                        width: 1920
                      )
                    }
                  }
                }
              }
              acfArtistPage {
                country
                hidden
              }
            }
          }
        }
      }
    `}
    render={(data) => <RelatedArtists data={data} {...props} />}
  />
);

// TODO: Add prop types
